// src/components/CircularProgress.jsx
import React, { useEffect, useRef, useState } from "react";
import "../CircularProgress.css";

const progressData = [
  { label: "Shopify", percent: "90%", className: "blue" },
  { label: "Wordpress", percent: "98%", className: "yellow" },
  { label: "E-Commerce", percent: "85%", className: "green" },
  { label: "SEO", percent: "92%", className: "pink" },
];

const CircularProgress = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Trigger only once
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div className="circular-wrapper" ref={containerRef}>
      {progressData.map((item, index) => (
        <div key={index} className="progress-container">
          <div className={`progress ${item.className} ${isVisible ? "animate" : ""}`}>
            <span className="progress-left">
              <span className="progress-bar"></span>
            </span>
            <span className="progress-right">
              <span className="progress-bar"></span>
            </span>
            <div className="progress-value">{item.percent}</div>
          </div>
          <div className="progress-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default CircularProgress;
